import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  loader: false,
};

export const startLoader = createAsyncThunk(
  "app/startLoader",
  async (_, { rejectWithValue }) => {
    try {
      return { loader: true };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const stopLoader = createAsyncThunk(
  "app/stopLoader",
  async (_, { rejectWithValue }) => {
    try {
      return { loader: false };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const appConfig = createAsyncThunk(
  "app/appConfig",
  async ({ isMobileDevice }, { rejectWithValue }) => {
    try {
      return { isMobileDevice };
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const appSlice = createSlice({
  name: "app",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(startLoader.fulfilled, (state, action) => {
        state.loader = action.payload.loader;
      })
      .addCase(stopLoader.fulfilled, (state, action) => {
        state.loader = action.payload.loader;
      })
      .addCase(appConfig.fulfilled, (state, action) => {
        state.isMobileDevice = action.payload.isMobileDevice;
      });
  },
});

export default appSlice.reducer;
